[
  {
  
    "id":1,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719013077?h=634562cd80",
    "title": "Welcome",
    "img": "../assets/accordion-img/01_gatehouse.jpg",
    "description" : "This step-by-step guided tour of our factory in Motherwell takes you through every part of our rigorous process. Click on the next icon to begin your factory experience.",
    "shape": "poly",
    "name": "1",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2173,
      934,
      2384,
      877,
      2327,
      828,
      2323,
      726,
      2214,
      620,
      2063,
      650,
      2067,
      677,
      2040,
      677,
      1984,
      610,
      2037,
      684,
      1991,
      695,
      1991,
      764
    ],
    "polygon": [  
      [2173,934],
      [2384,877],
      [2327,828],
      [2323,726],
      [2214,620],
      [2063,650],
      [2067,677],
      [2040,677],
      [1984,610],
      [2037,684],
      [1991,695],
      [1991,764]
    ],
    "iconCoords": [
      2173,600
    ]
  },
  {
    "id":2,
    "type": "video+nav",
    "url":"https://player.vimeo.com/video/719015469?h=9621686303",
    "title": "Design",
    "description" : "Take a look into how we design our haulers and the benefits of having everything under one roof.",
    "shape": "poly",
    "name": "2",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1973,
      1103,
      2222,
      1379,
      2380,
      1337,
      2384,
      1156,
      2256,
      1031,
      2199,
      971,
      2112,
      895,
      1973,
      922
    ],
    "polygon": [  
      [1973,1103],
      [2222,1379],
      [2380,1337],
      [2384,1156],
      [2256,1031],
      [2199,971],
      [2112,895],
      [1973,922]
    ],
    "iconCoords": [
      2323,1100
    ]
  },
  {
    "id": 3,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719016254?h=849e9928e6",
    "title": "Processing",
    "img": "./assets/accordion-img/03_processing.jpg",
    "description" : "See the part our mighty 1000-tonne press plays in every hauler, and the incredible numbers behind the process.",
    "shape": "poly",
    "name": "3",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1232,
      2035,
      1120,
      2063,
      977,
      1920,
      986,
      1743,
      1087,
      1715,
      1220,
      1843
    ],
    "polygon": [
      [1232, 2035],
      [1120, 2063],
      [977, 1920],
      [986, 1743],
      [1087, 1715],
      [1220, 1843]
    ],
    "iconCoords": [
      941,
      1723
    ]
  },
  {
    "id": 4,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719017411?h=8dfac17092",
    "title": "Machine Shop",
    "description" : "Watch the video and learn more about all the parts we manufacture in house, and why.",
    "shape": "poly",
    "name": "4",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      546,
      1552,
      629,
      1624,
      674,
      1624,
      735,
      1684,
      776,
      1661,
      780,
      1510,
      742,
      1503,
      678,
      1423,
      663,
      1412,
      625,
      1382,
      546,
      1397,
      546,
      1450
    ],
    "polygon": [
      [546,1552],
      [629,1624],
      [674,1624],
      [735,1684],
      [776,1661],
      [780,1510],
      [742,1503],
      [678,1423],
      [663,1412],
      [625,1382],
      [546,1397],
      [546,1450]
    ],
    "iconCoords": [
      500,1330
    ]
  },
  {
    "id": 5,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719019445?h=d4c569635c",
    "title": "Robotic Welder",
    "description" : "See our cutting-edge robotic welders in action and discover their amazing capabilities.",
    "shape": "poly",
    "name": "5",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      995,
      1587,
      1222,
      1534,
      1093,
      1421,
      1074,
      1263,
      878,
      1296,
      867,
      1365,
      780,
      1380
    ],
    "polygon": [  
    [995,1587],
    [1222,1534],
    [1093,1421],
    [1074,1263],
    [878,1296],
    [867,1365],
    [780,1380]
    ],
    "iconCoords": [
      1050,1200
    ]
  },
  {
    "id": 6,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719020683?h=45b9e3ef18",
    "title": "Quality Control",
    "description" : "Find out how our quality control team keep us reliable, consistent and safe.",
    "shape": "poly",
    "name": "6",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1184,
      1704,
      1312,
      1820,
      1452,
      1798,
      1456,
      1647,
      1323,
      1534,
      1191,
      1564
    ],
    "polygon": [  
      [1184,1704],
      [1312,1820],
      [1452,1798],
      [1456,1647],
      [1323,1534],
      [1191,1564]
    ],
    "iconCoords": [
      1150,1500
    ]
  },
  {
    "id": 7,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719020977?h=255fcd5981",
    "title": "Artic Body",
    "description" : "This is the biggest part of the Rokbak hauler – watch the video to see how we do it.",
    "shape": "poly",
    "name": "7",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1599,
      1662,
      1701,
      1644,
      1722,
      1605,
      1722,
      1579,
      1703,
      1552,
      1605,
      1458,
      1465,
      1488,
      1463,
      1526,
      1523,
      1587
    ],
    "polygon": [
      [1599,1662],
      [1701,1644],
      [1722,1605],
      [1722,1579],
      [1703,1552],
      [1605,1458],
      [1465,1488],
      [1463,1526],
      [1523,1587]
    ],
    "iconCoords": [
      1590,1400
    ]
  },
  {
    "id": 8,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719022570?h=3466b16b71",
    "title": "Artic Frame",
    "description" : "Take a look at how we put together the frame of the articulated hauler.",
    "shape": "poly",
    "name": "8",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1323,
      1412,
      1471,
      1375,
      1331,
      1235,
      1225,
      1212,
      1203,
      1287
    ],
    "polygon": [
      [1323,1412],
      [1471,1375],
      [1331,1235],
      [1225,1212],
      [1203,1287]
    ],
    "iconCoords": [
      1340,1180
    ]
  },
  {
    "id": 9,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719022803?h=07f383422c",
    "title": "Paint Shop",
    "description" : "On the surface, you might think it’s just cosmetic – but there are many benefits to painting.",
    "shape": "poly",
    "name": "9",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1822,
      1511,
      2018,
      1704,
      2240,
      1655,
      2244,
      1519,
      2029,
      1322,
      1822,
      1368
    ],
    "polygon": [  
      [1822,1511],
      [2018,1704],
      [2240,1655],
      [2244,1519],
      [2029,1322],
      [1822,1368]
    ],
    "iconCoords": [
      2000,1260
    ]
  },
  {
    "id":10,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719024267?h=718bc5a17a",
    "title": "Production Stores",
    "description" : "A lot of parts go into every hauler – this is where they’re organised and distributed.",
    "shape": "poly",
    "name": "10",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2320,
      1903,
      2263,
      1903,
      2229,
      1866,
      2244,
      1809,
      2248,
      1666,
      2286,
      1662,
      2425,
      1786,
      2425,
      1937,
      2373,
      1949
    ],
    "polygon": [  
      [2320,1903],
      [2263,1903],
      [2229,1866],
      [2244,1809],
      [2248,1666],
      [2286,1662],
      [2425,1786],
      [2425,1937],
      [2373,1949]
    ],
    "iconCoords": [
      2364,1701
    ]
  },
  {
    "id":11,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719025116?h=2169211c2a",
    "title": "Artic Assembly Line",
    "description" : "Our haulers really start to take shape here, on the assembly line.",
    "shape": "poly",
    "name": "11",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1757,
      1844,
      1949,
      2014,
      2097,
      1976,
      2006,
      1802,
      1886,
      1700,
      1746,
      1738,
      1750,
      1803
    ],
    "polygon": [  
      [1757,1844],
      [1949,2014],
      [2097,1976],
      [2006,1802],
      [1886,1700],
      [1746,1738],
      [1750,1803]
    ],
    "iconCoords": [
      1730,1720
    ]
  },
  {
    "id":12,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719025691?h=a099cabe87",
    "title": "Test Track",
    "description" : "Reliability is our backbone – this is where we make sure every hauler is ready to perform.",
    "shape": "poly",
    "name": "12",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2614,
      913,
      2822,
      1121,
      3022,
      1076,
      3052,
      1042,
      3063,
      997,
      3044,
      955,
      3018,
      925,
      2991,
      906,
      2957,
      891,
      2923,
      876,
      2871,
      868,
      2814,
      868
    ],
    "polygon": [  
      [2614,913],
      [2822,1121],
      [3022,1076],
      [3052,1042],
      [3063,997],
      [3044,955],
      [3018,925],
      [2991,906],
      [2957,891],
      [2923,876],
      [2871,868],
      [2814,868]
    ],
    "iconCoords": [
      2680,850
    ]
  },
  {
    "id":13,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719026113?h=347c594a6d",
    "title": "Finals & Inspection",
    "description" : "Every hauler is manufactured to the highest standard, every time. This is where we test their mettle.",
    "shape": "poly",
    "name": "13",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      1720,
      1372,
      1848,
      1341,
      1829,
      1270,
      1791,
      1232,
      1784,
      1190,
      1750,
      1156,
      1746,
      1081,
      1720,
      1054,
      1614,
      1085,
      1531,
      1115,
      1535,
      1202
    ],
    "polygon": [  
      [1720,1372],
      [1848,1341],
      [1829,1270],
      [1791,1232],
      [1784,1190],
      [1750,1156],
      [1746,1081],
      [1720,1054],
      [1614,1085],
      [1531,1115],
      [1535,1202]
    ],
    "iconCoords": [
      1705,1000
    ]
  },
  {
    "id":14,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719026797?h=35aa0e6cec",
    "title": "Training",
    "description" : "This is the home of our product support and excellent service. Here, we uphold our rigorous standards of product support and service excellent worldwide.",
    "shape": "poly",
    "name": "14",
    "open_reverse": true,
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2939,
      1285,
      3006,
      1349,
      3048,
      1334,
      3063,
      1375,
      3093,
      1349,
      3120,
      1380,
      3237,
      1357,
      3203,
      1330,
      3240,
      1323,
      3240,
      1251,
      3154,
      1172,
      2939,
      1213
    ],
    "polygon": [  
      [2939,1285],
      [3006,1349],
      [3048,1334],
      [3063,1375],
      [3093,1349],
      [3120,1380],
      [3237,1357],
      [3203,1330],
      [3240,1323],
      [3240,1251],
      [3154,1172],
      [2939,1213]
    ],
    "iconCoords": [
      3100,1100
    ]
  },
  {
    "id":15,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719031775?h=799ca911bd",
    "title": "Parts Distribution Warehouse",
    "description" : "Every part going to or from the factory comes through here – the distribution warehouse.",
    "shape": "poly",
    "name": "15",
    "open_reverse": true,
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2999,
      1646,
      3154,
      1615,
      3157,
      1517,
      2905,
      1279,
      2818,
      1249,
      2742,
      1317,
      2735,
      1396,
      2837,
      1491
    ],
    "polygon": [  
      [2999,1646],
      [3154,1615],
      [3157,1517],
      [2905,1279],
      [2818,1249],
      [2742,1317],
      [2735,1396],
      [2837,1491]
    ],
    "iconCoords": [
      2940,1500
    ]
  },
  {
    "id":16,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/719024322?h=9ba9c563ce",
    "title": "Customer Solutions",
    "description" : "Watch the video above to find out more about our dedicated customer solutions and support team.",
    "shape": "poly",
    "name": "16",
    "fillColor": "#ffffff00",
    "strokeColor": "#ffffff00",
    "coords": [
      2414,
      1557,
      2591,
      1712,
      2731,
      1689,
      2723,
      1463,
      2693,
      1433,
      2656,
      1444,
      2516,
      1304,
      2471,
      1319,
      2505,
      1357,
      2418,
      1372
    ],
    "polygon": [  
      [2414,1557],
      [2591,1712],
      [2731,1689],
      [2723,1463],
      [2693,1433],
      [2656,1444],
      [2516,1304],
      [2471,1319],
      [2505,1357],
      [2418,1372]
    ],
    "iconCoords": [
      2697,1420
    ]
  },
  {
    "id":17,
    "type": "video+nav",
    "url": "https://player.vimeo.com/video/720275513?h=09166c29fe",
    "title": "Test & Development",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      2669,1115
    ]
  },
  {
    "id":18,
    "type": "video--speaker",
    "url": "https://player.vimeo.com/video/719069308",
    "title": "Rokbak's Rockstars",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      250,1100
    ]
  },
  {
    "id":19,
    "type": "url--recycling",
    "url": "https://rokbak.com/sustainability",
    "title": "Sustainability",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      610,1129
    ]
  },
  {
    "id":20,
    "type": "url--visit",
    "url": "https://rokbak.com/welcome-to-scotland/",
    "title": "Welcome to Scotland",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      2458,672
    ]
  },
  {
    "id":21,
    "type": "url--download",
    "url": "https://rokbak.com/downloads/",
    "title": "Download Centre",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      2629,404
    ]
  },
  {
    "id":22,
    "type": "url--store",
    "url": "https://rokbak.com/merchandise",
    "title": "Merchandise",
    "description" : " ",
    "shape": "poly",
    "name": "17",
    "open_reverse": true,
    "fillColor": "#000000",
    "strokeColor": "#000000",
    "coords": [
      0
    ],
    "polygon": [  
     [0,0]
    ],
    "iconCoords": [
      2974,627
    ]
  }
]












